var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", lg: "6" } },
                    [
                      _c(
                        "v-expansion-panels",
                        { staticClass: "mb-3", attrs: { popout: "" } },
                        [
                          _c(
                            "v-expansion-panel",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "header",
                                  fn: function () {
                                    return [
                                      _c("div", { staticClass: "text-h6" }, [
                                        _vm._v(
                                          "Installed Capacity By Fuel Type"
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "ChartYearly",
                                _vm._b(
                                  { attrs: { visible: "", type: "doughnut" } },
                                  "ChartYearly",
                                  _vm.generatorChart,
                                  false
                                )
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("p", { staticClass: "mx-16" }, [_vm._v("Source: AA")]),
                    ],
                    1
                  ),
                  _vm._l(_vm.charts[0], function (data, index) {
                    return _c(
                      "v-col",
                      {
                        key: "" + index + data,
                        attrs: { cols: "12", sm: "6" },
                      },
                      [
                        _c("Plotly", {
                          attrs: {
                            data: data,
                            layout: _vm.charts[1][index],
                            toImageButtonOptions: _vm.chartDownloadName(
                              _vm.caseName,
                              "IRP",
                              _vm.charts[1][index].title
                            ),
                          },
                        }),
                        _c("p", { staticClass: "mx-16" }, [
                          _vm._v(
                            "Source: " + _vm._s(_vm.charts[1][index].output)
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }